module.exports = __webpack_public_path__ + "img/792d15c.jpg";